import { useFeatureFlag } from "@/contexts/FeatureFlagContext"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { TriangleAlert } from "lucide-react"
import type { NoteOut } from "../../../api/notesApi"
import { NoteText } from "../../shared/notes/NoteText"

interface InquirySupplierWarningBannerProps {
  supplierName: string | null
  /** The supplier's active warning notes, as the inquiry detail carries them. */
  warnings: NoteOut[] | undefined
}

/** Above the detail sections: this supplier has notes that ask for a warning. */
export function InquirySupplierWarningBanner({
  supplierName,
  warnings,
}: InquirySupplierWarningBannerProps) {
  const { translate } = useTranslation()
  const enabled = useFeatureFlag("MC_NOTES")
  if (!enabled || !warnings || warnings.length === 0) return null

  return (
    <div
      role="alert"
      className="flex gap-2.5 border-b border-attention/40 bg-attention/10 px-4 py-3 text-[12.5px] text-white"
    >
      <TriangleAlert size={15} className="mt-0.5 shrink-0 text-attention" />
      <div className="min-w-0">
        <div className="font-medium">
          {translate("MC_NOTE_BANNER_TITLE", { supplier: supplierName ?? "" })}
        </div>
        <ul className="mt-1 flex flex-col gap-1">
          {warnings.map((note) => (
            <li key={note.id}>
              <NoteText body={note.body} quoted />
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
